import { ConstructorWidgetEnum } from "../../../shared/types/constructor/widget.js";
const prepareFilterHistoryItemValue = (historyItem, filterItems) => {
  var _a, _b, _c;
  const filterItem = filterItems.find((item) => item.key === historyItem.key);
  if (!filterItem) {
    return null;
  }
  switch (filterItem.type) {
    case ConstructorWidgetEnum.FilterLocation:
    case ConstructorWidgetEnum.FilterMultipleSelect:
    case ConstructorWidgetEnum.FilterCheckboxGroup:
    case ConstructorWidgetEnum.FilterModels:
    case ConstructorWidgetEnum.FilterColorPicker:
    case ConstructorWidgetEnum.FilterDuoColorPicker: {
      const options = ((_a = filterItem.props) == null ? void 0 : _a.options) || [];
      const historyOption = options.find((option) => {
        return (option == null ? void 0 : option.value) === historyItem.value;
      });
      if (!historyOption) {
        return null;
      }
      const values = filterItem.value ?? [];
      const valueOnDeletion = values.filter((v) => v !== historyItem.value);
      return {
        ...historyItem,
        valueOnDeletion: valueOnDeletion.length ? valueOnDeletion : void 0,
        label: historyOption.label
      };
    }
    case ConstructorWidgetEnum.FilterSelect: {
      const options = ((_b = filterItem.props) == null ? void 0 : _b.options) || [];
      const historyOption = options.find((option) => {
        return (option == null ? void 0 : option.value) === historyItem.value;
      });
      if (!historyOption) {
        return null;
      }
      return {
        ...historyItem,
        valueOnDeletion: void 0,
        label: historyOption.label
      };
    }
    case ConstructorWidgetEnum.FilterSlider: {
      return {
        ...historyItem,
        valueOnDeletion: void 0,
        label: historyItem.value
      };
    }
    case ConstructorWidgetEnum.FilterRangeSlider: {
      if (!Array.isArray(historyItem.value) || historyItem.value.length < 2) {
        return null;
      }
      const defaultFormatter = (value) => value;
      const formatter = ((_c = filterItem.props) == null ? void 0 : _c.valueFormatter) ?? defaultFormatter;
      return {
        ...historyItem,
        valueOnDeletion: void 0,
        label: `${formatter(historyItem.value[0])} — ${formatter(historyItem.value[1])}`
      };
    }
    default:
      return null;
  }
};
export {
  prepareFilterHistoryItemValue
};
